import { Empty as EmptyA } from 'antd';
import cn from 'classnames';
import { RoundElement } from '../round-element';
import { Text } from '../typography';
import { EmptyDescription, type EmptyDescriptionProperties } from './empty-description';

export type EmptyProperties = {
  border?: boolean;
  description?: EmptyDescriptionProperties;
  fitCenter?: boolean;
  // Remove this maxWidth, max width should be always turn on, but for backward compatibility its prop
  // when all empty state will looks good with max width true remove this and set maxWidth class to be always applied
  maxWidth?: boolean;
  size?: 'default' | 'small';
  withoutImage?: boolean;
} & Omit<React.ComponentProps<typeof EmptyA>, 'description'>;

// TODO replace usage of description to `title` + `subtitle`
const Empty = ({
  border,
  className,
  description,
  fitCenter,
  image,
  maxWidth,
  size = 'default',
  withoutImage,
  ...rest
}: EmptyProperties) => (
  <EmptyA
    className={cn('empty-state', className, {
      'empty-state--border': border,
      'empty-state--fit-center': fitCenter,
      'empty-state--max-width': maxWidth,
      'empty-state--small': size === 'small',
      'empty-state--without-image': withoutImage,
    })}
    description={description ? <EmptyDescription description={description} /> : description}
    image={
      image ? (
        <RoundElement className="empty-state__icon" size="medium">
          {size === 'small' ? <Text size="large">{image}</Text> : image}
        </RoundElement>
      ) : undefined
    }
    {...rest}
  />
);

export default Empty;
